import hit_login from '@core/components/assets/hit_login'
import hit_dashboard from '@core/components/assets/hit_dashboard'
import hit_delete from '@core/components/assets/hit_delete'
import hit_stars from '@core/components/assets/hit_stars'
import hit_color from '@core/components/assets/hit_color'
import hit_badge from '@core/components/assets/hit_badge'
import hit_survey from '@core/components/assets/hit_survey'
import hit_votes from '@core/components/assets/hit_votes'
import hit_toggle from '@core/components/assets/hit_toggle'
import hit_table from '@core/components/assets/hit_table'
import hit_embed_code from '@core/components/assets/hit_embed_code'
import hit_icon from '@core/components/assets/hit_glyphicons'
import hit_limit from '@core/components/assets/hit_limitations'

export default {

  // The install method will be called with the Vue constructor as the first argument, along with possible options
  install (Vue, options) {
    const curl = options

    Vue.prototype.$hit_post = async function (data, url) {
      if (typeof url === 'undefined') { options.url = options.flix_url } else {
        options.url = options[url]
      }
      
      const post = await fetch(options.url + '/' + options.lang + '/' + data.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        },
        body: JSON.stringify(
          data.data
        )
      })

      const fetchy = await post.json()
      if (typeof data.callback === 'function') { data.callback({data: fetchy}) } else { console.log(ret) }
      
    }

    Vue.prototype.$get_url = function () {
      return {
        www_url: options.www_url,
        api_url: options.api_url
      }
    },

    Vue.prototype.$nl2br = function (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return ''
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>'
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
    }

    Vue.component('hit_embed_code', hit_embed_code)
    Vue.component('hit_login', hit_login)
    Vue.component('hit_dashboard', hit_dashboard)
    Vue.component('hit_delete', hit_delete)
    Vue.component('hit_stars', hit_stars)
    Vue.component('hit_color', hit_color)
    Vue.component('hit_badge', hit_badge)
    Vue.component('hit_survey', hit_survey)
    Vue.component('hit_votes', hit_votes)
    Vue.component('hit_toggle', hit_toggle)
    Vue.component('hit_table', hit_table)
    Vue.component('hit_icon', hit_icon)
    Vue.component('hit_limit', hit_limit)
  }
}
